import Alert from "@/components/ui/Alert";
import type { AlertItem } from "@/types/alert";

//#region Type
interface AlertsProps {
  messages: AlertItem[];
  onRemove: (id: number) => void;
}
//#endregion

const Alerts = ({ messages, onRemove }: AlertsProps) => {
  if (!messages.length) return null;

  return (
    <div className="brand-container fixed left-0 right-0 top-28 z-50 m-auto max-w-screen-md space-y-4">
      {messages.map((msg) => (
        <Alert key={msg.id} message={msg} onRemove={onRemove} />
      ))}
    </div>
  );
};

export default Alerts;
